var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "105.444mm",
    height: "14.4637mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9190 1261",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil1 {fill:#333333;fill-rule:nonzero}\r\n    .fil0 {fill:#A80000;fill-rule:nonzero}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M0 1261l0 -1261 531 0 314 860 310 -860 532 0 0 1261 -328 0 -1 -993 -345 993 -341 0 -343 -993 -1 993 -328 0zm3255 0l-382 0 -151 -287 -702 0 -145 287 -375 0 680 -1261 374 0 701 1261zm-648 -500l-243 -467 -236 467 479 0zm474 500l0 -1261 567 0c214,0 354,6 419,19 101,19 184,60 252,123 68,64 102,146 102,246 0,77 -20,142 -59,195 -39,53 -88,94 -148,124 -60,30 -121,50 -183,60 -84,12 -206,18 -366,18l-230 0 0 476 -354 0zm354 -1048l0 359 193 0c139,0 231,-7 278,-20 47,-13 84,-34 110,-62 27,-28 40,-61 40,-98 0,-46 -18,-84 -56,-114 -37,-30 -84,-49 -141,-56 -42,-6 -127,-9 -254,-9l-170 0zm2309 1048l-382 0 -151 -287 -702 0 -146 287 -374 0 679 -1261 375 0 701 1261zm-648 -500l-243 -467 -236 467 479 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_211468144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M8862 955l312 39c-40,87 -103,153 -189,199 -87,45 -195,68 -324,68 -206,0 -358,-51 -456,-153 -78,-82 -117,-185 -117,-310 0,-149 52,-266 154,-350 102,-84 231,-126 387,-126 175,0 314,44 415,132 102,88 150,223 146,405l-781 0c2,71 27,125 76,165 47,39 107,58 179,58 49,0 90,-10 123,-30 33,-20 58,-53 75,-97zm18 -241c-2,-69 -25,-121 -70,-157 -44,-36 -98,-54 -162,-54 -67,0 -124,19 -168,57 -44,38 -66,89 -65,154l465 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M7209 0l0 467c102,-93 223,-140 364,-140 72,0 137,11 195,31 58,21 102,47 132,80 29,31 49,67 60,106 11,39 16,100 16,181l0 536 -311 0 0 -482c0,-96 -7,-157 -18,-182 -12,-26 -34,-47 -64,-62 -30,-15 -68,-23 -114,-23 -53,0 -99,10 -140,30 -42,19 -72,48 -91,88 -19,39 -29,97 -29,173l0 458 -311 0 0 -1261 311 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M6778 607l-307 41c-10,-46 -34,-81 -71,-104 -36,-24 -84,-36 -142,-36 -78,0 -140,21 -187,62 -46,41 -69,109 -69,205 0,107 24,182 71,226 47,44 110,66 188,66 60,0 108,-13 146,-39 38,-25 64,-69 80,-132l307 39c-32,108 -93,189 -183,243 -90,55 -211,83 -364,83 -172,0 -309,-42 -412,-125 -103,-83 -154,-197 -154,-344 0,-148 52,-264 155,-346 102,-83 242,-124 417,-124 143,0 258,23 343,70 84,47 145,119 182,215z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.821b9e861aac1baec9122017856ae2f3.svg";
export { ForwardRef as ReactComponent };